import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Router";
import useUTMTracker from "./hooks/useUTMTracker";
import FraudAwarenessBanner from "./components/Common/FraudAwarenessBanner";

const App = () => {
  useUTMTracker();
  const location = useLocation();
  const isVideoKyc = location.pathname.startsWith("/video-kyc");
  useEffect(() => {
    AOS.init();
  }, []);

  const showmessage = async (message) => {
    try {
      var x = document.getElementById("snackbar");
      x.className = "show";
      x.innerText = message;
      setTimeout(function () {
        x.className = x.className.replace("show", "");
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
    <Router />
    {!isVideoKyc && <FraudAwarenessBanner />}
    </>
  );
};

export default App;
